export enum PostMessageTypesEnum {
  IFRAME_READY = 'IFRAME_READY',
  REDIRECT_TRACEABILITY = 'redirectToTraceability',
  REDIRECT_PMD = 'redirectToPmd',
  TOAST = 'toast'
}
